(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art_carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize carousels
    initArtistCarousels();
    
    // Reinitialize on window resize
    window.addEventListener('resize', function() {
      initArtistCarousels();
    });
  });

  function initArtistCarousels() {
    const carousels = document.querySelectorAll('.artist-gallery-carousel-track');
    
    carousels.forEach((carousel, index) => {
      // Skip if already initialized
      if (carousel.dataset.initialized) return;
      
      const direction = carousel.dataset.direction || 'right';
      const speed = parseFloat(carousel.closest('.artist-gallery-section').dataset.speed) || 0.5;
      const items = carousel.querySelectorAll('.artist-gallery-item');
      
      if (items.length === 0) return;
      
      // Mark as initialized
      carousel.dataset.initialized = 'true';
      
      const itemWidth = items[0].offsetWidth;
      const itemCount = items.length / 3; // We have 3 copies
      const totalWidth = itemCount * itemWidth;
      let position = direction === 'right' ? -totalWidth : 0;
      
      carousel.style.transform = `translateX(${position}px)`;
      
      function animate() {
        if (direction === 'right') {
          position += speed;
          if (position >= 0) {
            position = -totalWidth;
          }
        } else {
          position -= speed;
          if (position <= -totalWidth * 2) {
            position = -totalWidth;
          }
        }
        
        carousel.style.transform = `translateX(${position}px)`;
        requestAnimationFrame(animate);
      }
      
      // Start animation
      animate();
      
      // Pause on hover
      const container = carousel.closest('.artist-gallery-carousel-container');
      let currentSpeed = speed;
      
      container.addEventListener('mouseenter', () => {
        currentSpeed = 0;
      });
      
      container.addEventListener('mouseleave', () => {
        currentSpeed = speed;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arts_fair"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Elements
    // Use querySelectorAll to select all buttons with the class 'open-contact-popup'
    const openBtns = document.querySelectorAll('.open-contact-popup');
    const closeBtn = document.getElementById('closeContactPopup');
    const popup = document.getElementById('contactPopup');

    // Open popup for each button
    if (openBtns.length > 0) {
      openBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (popup) { // Check if popup exists before trying to display it
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
          }
        });
      });
    }

    // Close popup
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (popup) {
          popup.style.display = 'none';
          document.body.style.overflow = ''; // Restore scrolling
        }
      });
    }

    // Close on clicking outside content
    if (popup) {
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          popup.style.display = 'none';
          document.body.style.overflow = ''; // Restore scrolling
        }
      });
    }

    // Close with ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup && popup.style.display === 'flex') {
        popup.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const galleryGrid = document.querySelector('.gallery-grid');

  if (galleryGrid) {
    galleryGrid.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        galleryGrid.scrollLeft += e.deltaY * 2;
      }
    });

    galleryGrid.addEventListener('scroll', () => {
      clearTimeout(galleryGrid.scrollEndTimer);
      galleryGrid.scrollEndTimer = setTimeout(() => {
        const scrollLeft = galleryGrid.scrollLeft;
        const columnWidth = galleryGrid.querySelector('.gallery-column').offsetWidth;
        const snapPosition = Math.round(scrollLeft / columnWidth) * columnWidth;

        galleryGrid.scrollTo({
          left: snapPosition,
          behavior: 'smooth'
        });
      }, 100);
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["past-exhibition"] && !Shopify.designMode) return;
  try {
    
  // Only play clips that are on screen; pause the rest (bandwidth + battery).
  (function () {
    var vids = document.querySelectorAll('.pe-video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.pause(); io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peralax"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize all parallax items
    const parallaxItems = document.querySelectorAll('.parallax-item[data-parallax-enabled="true"]');
    
    parallaxItems.forEach(function(item) {
      const speed = parseFloat(item.dataset.parallaxSpeed) || 0.7;
      
      window.addEventListener('scroll', function() {
        if (item.offsetParent !== null) { // Only if element is visible
          const offset = window.pageYOffset;
          const itemOffset = item.getBoundingClientRect().top + window.pageYOffset;
          const itemHeight = item.offsetHeight;
          
          // Only apply parallax when the item is in view
          if (offset + window.innerHeight > itemOffset && offset < itemOffset + itemHeight) {
            const backgroundPos = (itemOffset - offset) * speed + 'px';
            item.style.backgroundPositionY = backgroundPos;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
